import {v4 as uuidv4} from 'uuid'

const list = [
  {
    id: uuidv4(),
    title: "langTitleUz",
    value: "uz",
  },
  {
    id: uuidv4(),
    title: "langTitleRu",
    value: "ru",
  },
  {
    id: uuidv4(),
    title: "langTitleTj",
    value: "tj",
  },
];

export default list;
